<template>
  <div class="app-activate-auto-top-up-wrapper">
    <activate-auto-top-up
      v-if="showActivated"
      :monthly-value="monthlyValue"
      :next-step="gotoSuccess"
      :topUp.sync = "topUp"
      :payment="autoTopUp.paymentType"
      :payment-type="true"
    >
      <template v-for="slot in possibleChildSlotsFor('Activate')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </activate-auto-top-up>
    <Success v-if="showSuccess"
             :show-logout="true"
             @done="goBack"
    >
      <template v-for="slot in possibleChildSlotsFor('ActSuccess')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
  </div>
</template>
<script>
import Success, { stepName as success } from '@/components/process/generic/TopUp/ChangeAutoTopUp/bild/Success.vue'
import { mapGetters, mapMutations } from 'vuex'
import ActivateAutoTopUp, { stepName as activateStepName } from '@/components/process/generic/TopUp/ChangeAutoTopUp/bild/ActivateAutoTopUp.vue'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'

export default {
  name: 'ActivateAutoTopUpWrapper',
  data () {
    return {
      topUp: {
        amount: 0,
        trigger: 0,
        type: null
      }
    }
  },
  created () {
    this.setActivationView(activateStepName)
  },
  computed: {
    ...mapGetters('topUp', [
      'getActivationView'
    ]),
    gotoSuccess () {
      return success
    },
    showActivated () {
      return this.getActivationView === activateStepName
    },
    showSuccess () {
      return this.getActivationView === success
    }
  },
  methods: {
    ...mapMutations('topUp', [
      'setCurrentView', 'setActivationView'
    ]),
    goBack () {
      this.setCurrentView('default')
    }
  },
  props: {
    showLogout: {
      type: Boolean,
      default: true
    },
    autoTopUp: {
      type: Object
    },
    monthlyValue: {
      type: Array
    },
    payment: {
      type: Object,
      required: true
    },
    paymentType: {
      type: Boolean,
      required: false
    }
  },
  components: { ActivateAutoTopUp, Success },
  mixins: [
    slotProxy(),
    transaction('changeAutoTopUp')
  ]
}
</script>
